// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3FaH6","buttons":"PendingPaymentAlert_buttons__vMXZJ"};